import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, useLocation } from 'react-router';
import configureStore from 'store';

const LocationChangeListener = ({ store }) => {
    const location = useLocation();

    useEffect(() => {
        store.dispatch({
            type: '@@router/LOCATION_CHANGE',
            payload: location,
        });
    }, [location, store]);

    return null;
};

export default ({ children, initialState = {} }) => {
    const store = configureStore(initialState);

    return <Provider store={store}>
        <BrowserRouter>
            <LocationChangeListener store={store} />
            { children }
        </BrowserRouter>
    </Provider>
}
